const NewIcon = ()=>{
    return (
        <div className="NewIcon">
            <p>New</p>       
        </div>
    )
}
export default NewIcon